import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const hitsPerPage = 10;

export const searchAttributes = [
  // Posts.
  'post_title',
  'post_body_searchable',
  'post_author_nickname',

  // Comments.
  'comment_message_searchable',
  'comment_author_nickname',
  'parent_comment_author_nickname',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'entity_type',
    field: 'entity_type.keyword',
    type: 'string',
  },
];

export const resultAttributes = [
  // General.
  'url',
  'entity_type',

  // Posts.
  'post_created',
  'post_title',
  'post_body_searchable',
  'post_author_avatar',
  'post_author_nickname',

  // Comments.
  'comment_link',
  'comment_created',
  'comment_post_title',
  'comment_message_searchable',
  'comment_author_avatar',
  'comment_author_nickname',
];

export const highlightAttributes = [
  // Posts.
  'post_title',
  'post_body_searchable',
  'post_author_nickname',

  // Comments.
  'comment_message_searchable',
  'comment_author_nickname',
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _created_asc: {
    field: 'aggregated_created',
    order: 'asc',
  },
  _created_desc: {
    field: 'aggregated_created',
    order: 'desc',
  },
};
